import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../spacesPlatform/utils/actionParams';

export class DeleteDataSourceVersionsRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('deleteDatasourceVersions', { ids: ids });
  }
}
